var $destinationSelect,
    $destination,
    $feesToggle,
    $rateWithFees,
    $rateWithoutFees,
$rangeSliderInputs;

$(document).ready(function ($) {
    $destinationSelect = $('.js-destination-select');
    $destination = $('.js-destination');
    $feesToggle = $('.js-show-fees');
    $rateWithFees = $('.js-rate-with-fees');
    $rateWithoutFees = $('.js-rate-without-fees');
    $rangeSliderInputs = $('.js-range-slider-input');

    $destinationSelect.on('change', function () {
        const val = parseInt($(this).val());
        const shipment_type = $(this).data('shipment_type');
        $destination.each(function () {
            if ($(this).data('shipment_type') !== shipment_type) return;

            var destination = $(this).data('destination');
            if (destination === val) {
                $(this).removeClass('is-hidden');
            } else {
                $(this).addClass('is-hidden');
            }
        });
    });

    $feesToggle.change(function() {
        if(this.checked) {
            $rateWithFees.each(function () {
                $(this).removeClass('is-hidden');
            });
            $rateWithoutFees.each(function () {
                $(this).addClass('is-hidden');
            });
            return;
        }
        $rateWithFees.each(function () {
            $(this).addClass('is-hidden');
        });
        $rateWithoutFees.each(function () {
            $(this).removeClass('is-hidden');
        });
    });

    $rangeSliderInputs.on('input', function() {
        var package_type = $(this).data('package-type');
        var destination = $(this).data('destination');

        $('.js-range-grid').each(function () {
            if ($(this).data('package-type') !== package_type || $(this).data('destination') !== destination) return;
            $(this).removeClass('is-current');
        });
        $('.js-range-grid[data-index=' + $(this).val() + '][data-package-type=' + package_type +'][data-destination=' + destination +']').addClass('is-current');

        $('.js-range-header').each(function () {
            if ($(this).data('package-type') !== package_type || $(this).data('destination') !== destination) return;
            $(this).removeClass('is-current');
        });
        $('.js-range-header[data-index=' + $(this).val() + '][data-package-type=' + package_type +'][data-destination=' + destination +']').addClass('is-current');
    });
});
